module.exports = __webpack_public_path__ + "img/badge-most-conversion-keyvue-pink.9df83d8b.png";